import { Info } from "lucide-react";
import { START } from "../lib/inhalte";

export const Ablauf = () => {
  const a = START.ablauf;
  return (
    <section id="ablauf" data-testid="ablauf" className="bg-stein-50 py-16 md:py-24 border-t border-stein-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-sm font-semibold text-chemara-violet mb-2">{a.label}</div>
        <h2 className="font-heading text-3xl md:text-5xl text-stein-900 leading-tight">{a.titel}</h2>
        <ol className="mt-8 md:mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {a.schritte.map((s, i) => (
            <li key={s.titel} className="bg-white rounded-xl border border-stein-200 p-6">
              <div className="h-10 w-10 rounded-full bg-chemara-violet text-white grid place-items-center font-semibold">{i + 1}</div>
              <h3 className="mt-4 font-heading text-xl text-stein-900">{s.titel}</h3>
              <p className="mt-2 text-[15px] text-stein-700 leading-relaxed">{s.text}</p>
            </li>
          ))}
        </ol>
        <p className="mt-6 flex gap-3 items-start text-[15px] text-stein-700 leading-relaxed max-w-3xl">
          <Info size={18} className="text-chemara-violet shrink-0 mt-0.5" />
          {a.unverbindlich}
        </p>
      </div>
    </section>
  );
};
